const V = "?v=av2027b";
const SRC = { tortora: `/brand/av-tortora-256.webp${V}`, navy: `/brand/av-navy-256.webp${V}`, nero: `/brand/av-nero-256.webp${V}`, bianco: `/brand/av-bianco-256.webp${V}` };
const SRC2X = SRC;
const H = { xs: "h-5", sm: "h-7", md: "h-9", lg: "h-14" };

export const BrandMark = ({ color = "navy", size = "sm", className = "" }) => (
  <img src={SRC[color]} srcSet={`${SRC[color]} 1x, ${SRC2X[color]} 3x`} alt="" aria-hidden="true" width={256} height={222} decoding="async" className={`${H[size]} w-auto select-none ${className}`} data-testid="brand-mark" />
);

export const BrandWordmark = ({ className = "", sub }) => (
  <span className={`leading-none ${className}`} data-testid="brand-wordmark">
    <span className="pp-serif tracking-[0.22em]">AMALFI VIBES</span>
    {sub && <span className="block text-[8px] tracking-[0.35em] opacity-70 mt-1">{sub}</span>}
  </span>
);

export const BrandLogo = ({ color = "navy", size = "sm", sub, className = "", textClass = "text-xl" }) => (
  <span className={`inline-flex items-center gap-2.5 ${className}`} aria-label="AMALFI VIBES" data-testid="brand-logo">
    <BrandMark color={color} size={size} />
    <BrandWordmark sub={sub} className={textClass} />
  </span>
);
